import update from 'immutability-helper';
import { combineReducers } from 'redux'

const Redux = require('redux');

const defaultState = {
  currentUser: null,
  signedIn: null,
  provider: null
};

const defaultSettingsState = {
  account: {},
  accountConfigurations: {},
  currentUser: null
};

const defaultAccountState = {
  account: {},
  accountConfigurations: {},
  accountId: {},
  accountProfanityConfiguration: {}
}

const initialState = {
  totalReactions: {},
  pageUserReaction: {},
  isSet: false,
  sumOfReactionCount: 0
}

const formLoginState = {
  passwordReset: false,
  initialLoad: true,
  screen: 'signin',
  userName: "",
  loginObj: {
    email: "",
    password: ""
  },
  errors: {},
  captchaResponse: null,
  signinFields: ['email', 'password'],
  source: "",
  apiErrors: {}
}

function reactionReducers(state = initialState, action) {
  switch(action.type) {
    case 'INITIAL':
      return {
        ...state,
        totalReactions: action.totalReactions,
        pageUserReaction: action.pageUserReaction,
        sumOfReactionCount: action.sumOfReactionCount
      }
    case 'INIT_TOTAL_REACTIONS':
      return {
        ...state,
        totalReactions: action.totalReactions,
        sumOfReactionCount: action.sumOfReactionCount
      };
    case 'INIT_USER_PAGE_REACTIONS':
      return {
        ...state,
        pageUserReaction: action.pageUserReaction
      };
    case 'INCREMENT':
      return {
        ...state,
        totalReactions: action.totalReactions,
        pageUserReaction: action.pageUserReaction,
        sumOfReactionCount: action.sumOfReactionCount
      };
    case 'DECREMENT':
      return {
        ...state,
        totalReactions: action.totalReactions,
        pageUserReaction: {},
        sumOfReactionCount: action.sumOfReactionCount
      };
    case 'SET':
      return {
        ...state,
        isSet: action.isSet
      };
    case 'RESET':
      return {
        ...state,
        pageUserReaction: {}
      }
    default:
      return state;
  }
}

function loginReducers(state = defaultState, action) {
  switch(action.type) {
    case "LOGIN_SETUSER": return update(state, {currentUser: {$set: action.currentUser}, signedIn: {$set: action.signedIn}, provider: {$set: action.provider}})
    case "LOGIN_CLEAR": return update(state, {currentUser: {$set: null}, signedIn: {$set: action.signedIn}});
    default: return state;
  }
}

function accountReducers(state = defaultAccountState, action) {
  switch(action.type) {
    case "ACCOUNT": return update(state,{
      accountId: {$set: action.accountId},
      account: {$set: action.account},
      accountConfigurations: {$set: action.accountConfigurations},
      accountProfanityConfiguration: {$set: action.accountProfanityConfiguration},
      accountAdministrators: {$set: action.accountAdministrators},
      bannedUsers: {$set: action.bannedUsers}
    });
    default: return state;
  }
}

function formLoginReducers(state = formLoginState, action) {
  switch(action.type) {
    case "SCREEN": return {
      ...state,
      screen: action.screen,
      initialLoad: action.initialLoad,
      passwordReset: action.passwordReset,
      signinFields: action.signinFields,
      source: action.source
    }
    case "LOGIN": return {
      ...state,
      loginObj: action
    }
    case "CAPTCHA": return {
      ...state,
      captchaResponse: action.captchaResponse
    }
    case "ERRORS" : return {
      ...state,
      errors: action
    }
    case 'API_ERRORS': return {
      ...state,
      apiErrors: action
    }
    default: return state;
  }
}

const combinedLoginReducers = combineReducers({
  loginReducers,
  formLoginReducers
})

export const FormLoginStore = Redux.createStore(formLoginReducers);
export const ReactionStore = Redux.createStore(reactionReducers);
export const Store = Redux.createStore(loginReducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
export const CombinedReducerStore = Redux.createStore(combinedLoginReducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
export const AccountStore = Redux.createStore(accountReducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());



// WEBPACK FOOTER //
// ./app/javascript/store.js